<template>
  <div>
    <el-form :inline="true" :model="searchForm" ref="searchRef">
      <el-form-item label="" v-if="envCrm">
        <el-select
          v-model="searchForm.refundType"
          clearable
          filterable
          style="width: 230px"
          placeholder="请选择回款类型"
          @change="handleSearch"
        >
          <el-option
            v-for="item in refundTypeList"
            :key="item.uid"
            :label="item.name"
            :value="item.uid"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <div class="select-data-picker">
          <el-select v-model="searchDateType" @change="handleSearch">
            <el-option label="回款日期" :value="1"></el-option>
            <el-option label="创建日期" :value="2"></el-option>
          </el-select>
          <el-date-picker
            style="width: 220px"
            value-format="yyyy-MM-dd"
            :editable="false"
            v-model="searchTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleSearch($event, 'datePickerChange')"
          >
          </el-date-picker>
        </div>
      </el-form-item>

      <el-form-item label>
        <el-select style="width: 230px" v-model="searchForm.customerIdList" filterable clearable multiple collapse-tags placeholder="请选择客户名称" @change="handleSearch">
          <el-option
            v-for="item in customerList"
            :key="item.uid"
            :label="item.name"
            :value="item.uid"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-cascader
          placeholder="请选择业务结算部门"
          style="width: 230px"
          v-model="searchForm.businessAccountDeptList"
          :options="deptOptions"
          :props="{ children: 'childrenDept', label: 'departmentName', value: 'departmentId' }"
          filterable
          clearable
          @change="handleSearch"
        >
        </el-cascader>
      </el-form-item>

      <el-form-item label>
        <el-select style="width: 230px" v-model="searchForm.myReceivableCompanyList" filterable clearable multiple collapse-tags placeholder="请选择我方收款公司" @change="handleSearch">
          <el-option
            v-for="item in bankList"
            :key="item.myReceivableCompanyCode"
            :label="item.myReceivableCompanyName"
            :value="item.myReceivableCompanyCode"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label>
        <el-select style="width: 230px" v-model="searchForm.userIdList" filterable clearable multiple collapse-tags placeholder="请选择业务员" @change="handleSearch">
          <el-option
            v-for="item in userList"
            :key="item.salesmanCode"
            :label="item.salesmanName"
            :value="item.salesmanCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import services from '@/services/api/compact'
import cookie from "js-cookie";

export default {
  name: 'PaybackSearch',
  data() {
    return {
      searchDateType: 1,
      searchTime: [],
      searchDate: {
        payBackStartDate: null,
        payBackEndDate: null,
        createdStartDate: null,
        createdEndDate: null,
      },
      searchForm: {
        customerIdList: null,
        businessAccountDeptList: null,
        userIdList: null,
        myReceivableCompanyList: null,
      },
      customerList: [],
      businessDeptList: [],
      bankList: [],
      userList: [],
      deptOptions: [],
      refundTypeList: [],
      envCrm: cookie.get("_env_crm__") !== "false",
    };
  },
  mounted() {
    this.handleGetBankInfo()
    this.handleGetCustomerList()
    this.handleGetSalesManList()
    this.handleGetDept()
    this.handleGetRefundTypeList()
  },
  methods: {
    handleInitTreeData(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((item) => {
          if (item.childrenDept.length === 0) {
            delete item.childrenDept
          }
          this.handleInitTreeData(item.childrenDept)
        })
      }
      return arr
    },
    async handleGetDept() {
      const { data } = await services.apiGetAllDept()
      this.deptOptions = this.handleInitTreeData(data.data)
    },
    async handleGetCustomerList() {
      const { data } = await services.apiGetCustomerList()
      this.customerList = data.data
    },
    async handleGetBankInfo() {
      const { data } = await services.apiGetMyBankInfo()
      this.bankList = data.data
    },
    async handleGetSalesManList() {
      const { data } = await services.apiGetSalesManList()
      this.userList = data.data
    },
    handleSearch($event, type) {
      Object.keys(this.searchDate).forEach((key) => {
        this.searchDate[key] = null
      })
      const dateTypeList = ['payBack', 'created']
      if (this.searchTime && this.searchDateType) {
        this.searchDate[`${dateTypeList[this.searchDateType - 1]}StartDate`] = this.searchTime[0]
        this.searchDate[`${dateTypeList[this.searchDateType - 1]}EndDate`] = this.searchTime[1]
      }
      this.searchForm = { ...this.searchForm, ...this.searchDate }

      this.$emit('handle-search')
    },
    // 获取回款类型字典
    async handleGetRefundTypeList() {
      const { data } = await services.apiGetCategoryData({ code: 'category_refund_type' })
      this.refundTypeList = data.results
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-select__tags-text {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-wrap: nowrap;
}
/deep/ .el-select .el-tag__close.el-icon-close {
  top: -7px;
}
/deep/ .el-select__tags {
  flex-wrap: nowrap;
}
</style>
